import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { DEFAULT_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/useDocumentSigning"
import {
  De_signSickLeaveDocumentInput,
  useDeSignSickLeaveMutation as useDeSignSickLeaveMutationType,
} from "@/modules/patients/detail/therapy-prescription/de/services/__generated__/useDeSignSickLeaveMutation.graphql"

const mutation = graphql`
  mutation useDeSignSickLeaveMutation($input: De_signSickLeaveDocumentInput!) {
    de_signSickLeaveDocument(input: $input) {
      de_SickLeave {
        id
        createdAt
        createdBy
        signedBy
        signedAt
        updatedAt
        updatedBy
        fileId
        ...deSickLeaveFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useDeSignSickLeaveMutationType>, "variables"> & {
  id: De_signSickLeaveDocumentInput["id"]
}

const useDeSignSickLeaveMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeSignSickLeaveMutationType>(
    mutation,
    DEFAULT_SIGNING_MUTATION_PARAMS,
  )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeSignSickLeaveMutation }
